import { IconProps } from '../icon';

export function FranceIcon(props: IconProps) {
  return (
    <svg height="600" width="900" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="m0 0h900v600h-900z" fill="#ed2939" />
      <path d="m0 0h600v600h-600z" fill="#fff" />
      <path d="m0 0h300v600h-300z" fill="#002395" />
    </svg>
  );
}

export default FranceIcon;
